import PropTypes from 'prop-types';
import React from 'react';
import { useGroupNotificationText } from '@/features/chats/viewmodels/useGroupNotificationText';
import MessageLabel from '@/features/chats/ui/Conversation/MessageCards/MessageLabel';

/**
 * Renders a group notification message as a centered separator card.
 */
const GroupNotificationCard = ({ message }) => {
   const notificationText = useGroupNotificationText(message);

   return <MessageLabel text={notificationText} />;
};

GroupNotificationCard.propTypes = {
   message: PropTypes.shape({
      publisherId: PropTypes.string,
      userId: PropTypes.string,
      profileUpdatedStatus: PropTypes.string,
      chatType: PropTypes.string,
   }).isRequired,
};

export default GroupNotificationCard;
